
<td>{{ patientGroup.name }}</td>
<td>Le {{ formatedUpdatedAt }}</td>
<td>{{patientGroup.activatedPatientCount}} {{patientGroup.patientCount > 1 ? 'patients' : 'patient'}}</td>
<td>
  <div #dropdown="bs-dropdown"
       (click)="$event.stopPropagation()"
       class="dropdown"
       container="body"
       dropdown>
  <button #bAct
          type="button"
          class="btn btn-outline-primary btn-outline icon-only circle"
          dropdownToggle>
    <i i-bs name="three-dots" width="15" height="15"></i>
  </button>
  <div class="dropdown-backdrop fade" (click)="dropdown.hide()"></div>
    <ul *dropdownMenu
        class="dropdown-menu dropdown-menu-right"
        [class.dropstart]="!offsetDropdown(bAct, 100)"
        [class.dropend]="offsetDropdown(bAct, 100)"
        role="menu">
      <li role="menuitem"> <span class="dropdown-item" id="action-edit" (click)="dropdown.hide(); onEdit.emit()">Éditer</span></li>
      <li role="menuitem"> <span class="dropdown-item" id="action-delete" (click)="dropdown.hide(); onDelete.emit()">Supprimer</span></li>
      <li class="divider dropdown-divider"></li>
      <li role="menuitem"><span id="cancel-link" class="dropdown-item action" (click)="dropdown.hide()">Annuler</span>
      </li>
    </ul>
  </div>
</td>
